<section class="page-head">
  <div>
    <h1>{{ 'admin.companies_title' | translate }}</h1>
    <p>{{ 'admin.companies_subtitle' | translate }}</p>
  </div>
  <button type="button" class="dm-a-btn primary" (click)="openCreate()">
    <i-tabler name="building-plus" class="icon-18"></i-tabler>{{ 'admin.new_company' | translate }}
  </button>
</section>

<section class="toolbar">
  <label class="search">
    <i-tabler name="search" class="icon-18"></i-tabler>
    <input type="search" [(ngModel)]="search" [placeholder]="'admin.search_companies' | translate"
           [attr.aria-label]="'admin.search_companies' | translate"/>
  </label>
</section>

@if (error) {
  <p class="dm-a-error" role="alert">{{ error }}</p>
}

<div class="card">
  @if (loading) {
    <div class="state"><mat-spinner diameter="32"></mat-spinner></div>
  } @else if (visibleCompanies.length === 0) {
    <div class="state">
      <i-tabler name="building" class="icon-32"></i-tabler>
      <p>{{ (search ? 'admin.no_results' : 'admin.no_companies') | translate }}</p>
    </div>
  } @else {
    <table class="data-table">
      <thead>
        <tr>
          <th>{{ 'admin.company' | translate }}</th>
          <th class="hide-md">{{ 'admin.vat_number' | translate }}</th>
          <th class="num">{{ 'admin.users_count' | translate }}</th>
          <th class="num hide-md">{{ 'admin.documents_count' | translate }}</th>
          <th>{{ 'admin.status' | translate }}</th>
          <th class="actions-col"><span class="sr-only">{{ 'admin.actions' | translate }}</span></th>
        </tr>
      </thead>
      <tbody>
        @for (company of visibleCompanies; track company.id) {
          <tr>
            <td>
              <div class="person-text">
                <strong>{{ company.name }}
                  @if (company.id === myCompanyId) {
                    <em class="you">{{ 'admin.your_company' | translate }}</em>
                  }
                </strong>
                <span>{{ company.email }}</span>
              </div>
            </td>
            <td class="hide-md">{{ company.vat_number }}</td>
            <td class="num">
              <button type="button" class="link-btn" (click)="showUsers(company)">{{ company.users_count }}</button>
            </td>
            <td class="num hide-md">{{ company.documents_count }}</td>
            <td>
              <span class="dm-a-badge" [class.active]="company.enabled" [class.disabled]="!company.enabled">
                {{ (company.enabled ? 'admin.company_active' : 'admin.company_inactive') | translate }}
              </span>
            </td>
            <td class="actions-col">
              <button type="button" class="icon-btn" [matMenuTriggerFor]="menu" [attr.aria-label]="'admin.actions' | translate">
                <i-tabler name="dots-vertical" class="icon-18"></i-tabler>
              </button>
              <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="showUsers(company)">
                  <i-tabler name="users" class="icon-18 m-r-8"></i-tabler>{{ 'admin.show_users' | translate }}
                </button>
                <button mat-menu-item (click)="inviteAdmin(company)">
                  <i-tabler name="user-plus" class="icon-18 m-r-8"></i-tabler>{{ 'admin.invite_admin' | translate }}
                </button>
                <button mat-menu-item (click)="openEdit(company)">
                  <i-tabler name="pencil" class="icon-18 m-r-8"></i-tabler>{{ 'admin.edit' | translate }}
                </button>
                @if (company.id !== myCompanyId) {
                  @if (company.enabled) {
                    <button mat-menu-item (click)="setEnabled(company, false)">
                      <i-tabler name="building-off" class="icon-18 m-r-8"></i-tabler>{{ 'admin.disable' | translate }}
                    </button>
                  } @else {
                    <button mat-menu-item (click)="setEnabled(company, true)">
                      <i-tabler name="circle-check" class="icon-18 m-r-8"></i-tabler>{{ 'admin.enable' | translate }}
                    </button>
                  }
                }
              </mat-menu>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
